import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useContributionsPageState } from '#src/app/pages/accountSettings/contributions/main/pageContext';
import { useSession } from '#src/app/shared/hooks/session';

export function useCardInfo(): {
	currentCardInfo: string;
} {
	const [{ subscription }] = useContributionsPageState();
	const { translate } = useI18n();

	const session = useSession();

	const userCountry = session.user?.country ?? null;

	const currentCardInfo: string = useMemo(() => {
		switch (subscription.paymentMethod.__typename) {
			case 'PaymentMethodPayPal':
				return translate('fe.components.paypal.payment_source_info', {
					email: subscription.paymentMethod.email,
				});

			case 'PaymentMethodVenmo':
				return translate('corgi.payments.venmo.payment_source_info', { username: subscription.paymentMethod.username });

			case 'PaymentMethodCreditCard':
				return translate('fe.pages.subscriptions.manage.current_card_info', {
					cardBrand: subscription.paymentMethod.brand,
					last4: subscription.paymentMethod.last4,
					expMonth: subscription.paymentMethod.expiryMonth,
					expYear: subscription.paymentMethod.expiryYear,
				});

			case 'PaymentMethodSepa':
				return translate('fe.components.sepa.bank_account_details', {
					countryCode: userCountry?.countryCode ?? '',
					country: userCountry?.displayName ?? '',
					last4: subscription.paymentMethod.last4,
				});

			default:
				return '';
		}
	}, [userCountry, subscription, translate]);

	return {
		currentCardInfo,
	};
}
